import styled from 'styled-components';
import IcoMoon from 'react-icomoon';

// TODO: Fix the possible sizes later when needed
const renderSize = ({ size }: any) => {
  switch (size) {
    case 'xxs':
      return '16px';
    case 'xs':
      return '20px';
    case 'sm':
      return '25px';
    case 'md':
      return '30px';
    case 'lg':
      return '35px';
    case 'xl':
      return '40px';
    case 'xxl':
      return '50px';
    default:
      return '30px';
  }
};

export const IconComponent = styled(IcoMoon)`
  width: ${({ size }) => renderSize({ size })};
  min-width: ${({ size }) => renderSize({ size })};
  height: ${({ size }) => renderSize({ size })};
  ${({ rotate }) => (rotate ? `transform: rotate(${rotate}deg)` : '')};
  path {
    fill: ${({ color }) => color};
  }
`;
